var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtaMeetingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3802 7.33149C12.2066 6.69204 12.2066 5.44438 11.3802 4.80493C8.88267 2.87244 6.09384 1.34925 3.11808 0.292372L2.57445 0.0992942C1.53441 -0.27009 0.435847 0.433585 0.295047 1.50718C-0.0983489 4.50683 -0.0983491 7.62959 0.295047 10.6292C0.435846 11.7028 1.53441 12.4065 2.57445 12.0371L3.11808 11.844C6.09384 10.7872 8.88267 9.26398 11.3802 7.33149Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtaMeetingIcon);
export default __webpack_public_path__ + "static/media/PTA_meeting_icon.ae2f3f89fc3ce5768fc36a7cd31ba869.svg";
export { ForwardRef as ReactComponent };